<template>
  <div class="audiology-kpis__teaser">
    <img class="audiology-kpis__teaser-image" src="/images/kpis.png">
    <div class="audiology-kpis__teaser-overlay">
      <div class="audiology-kpis__teaser-message">
        <div class="tab__sub-header">NO KPI DATA UPLOADED</div>
        <p>Please speak with your <a class="audiology-kpis__teaser-rm-link" @click.stop="activateModal">regional manager</a> about getting this data into the system.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Teaser',
    computed: {
      ...mapGetters('main', ['fuelEmployee']),
    },
    methods: {
      activateModal () {
        if (this.fuelEmployee) {
          alert('This functionality is reserved for members only.');
        } else {
          this.$store.dispatch('main/showModal', 'contactRM');
        }
      },
    },
  };
</script>
